import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import { api } from '../api/client';
import { PageHeader } from '../components/Layout';
import { Badge, Card, JsonBlock, KeyValue, QueryBoundary } from '../components/ui';
import { dateTime } from '../lib/format';

export default function StrategyDetail() {
  const { id } = useParams<{ id: string }>();
  const iid = Number(id);
  const q = useQuery({
    queryKey: ['strategy', iid],
    queryFn: () => api.strategy(iid),
    enabled: Number.isFinite(iid),
  });
  const s = q.data;

  return (
    <>
      <PageHeader
        title={`Strategy instance ${id}`}
        actions={
          <Link className="text-sm text-sky-400 hover:underline" to="/strategies">
            ← all strategies
          </Link>
        }
      />
      <QueryBoundary q={q}>
        {s && (
          <div className="space-y-5">
            <Card className="p-4">
              <KeyValue
                rows={[
                  ['Strategy', s.strategy_id],
                  ['Version', s.strategy_version],
                  ['Symbol', s.symbol],
                  ['Timeframe', s.timeframe],
                  ['Account', s.account_id ?? 'any'],
                  ['State', s.enabled ? <Badge tone="good">enabled</Badge> : <Badge>disabled</Badge>],
                  ['Enabled at', dateTime(s.enabled_at)],
                  ['Disabled at', dateTime(s.disabled_at)],
                  ['Last changed by', s.last_changed_by ?? '—'],
                  ['Signals emitted', s.signal_count],
                  ['Permitted regimes', s.permitted_regimes.join(', ') || 'all'],
                ]}
              />
            </Card>
            <Card className="p-4">
              <h2 className="mb-3 text-sm font-medium text-slate-300">Parameters</h2>
              <JsonBlock value={s.params} />
            </Card>
          </div>
        )}
      </QueryBoundary>
    </>
  );
}
